import { ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute, Data, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { PropertyTenantsService } from './tenants.service';
import { Project, ProjectPagination, Pipeline, Property, Address } from 'app/modules/projects/projects.types';

@Component({
  selector: 'project-tenants',
  templateUrl: './tenants.component.html',
  styleUrls: ['./tenants.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectTenantsComponent {
  @ViewChild('drawer')
  drawer: MatDrawer;

  drawerMode: 'over' | 'side';
  drawerOpened: boolean;

  properties: Property[] = [];

  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _propertyTenantsService: PropertyTenantsService,
  ) {
    this.drawerMode = 'side';
    this.drawerOpened = true;

    //this._checkRedirectToFirstPipeline(this._activatedRoute)

    this._router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        //default route if navigate
        //this._checkRedirectToFirstPipeline(this._activatedRoute)
      }
    });
  }

  /* Check if we should redirect to first pipeline
   */
  _checkRedirectToFirstPipeline(route): void {
    if (!route.snapshot.firstChild && this.properties.length > 0) {
      this._router.navigate(['./', this.properties[0].id], { relativeTo: route });
    }
  }
}
